export function clearAllKeysFromStorageStartingWith(startsWith) {
  // Get all keys from localStorage
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    // Check if key starts with the specified prefix
    if (key && key.startsWith(startsWith)) {
      localStorage.removeItem(key);
    }
  }
}
